export default __webpack_public_path__ + "static/media/ELIKSIR-00308.406f1ec4.JPG";